import React from "react";
import { Button, Modal } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight, faEdit, faTimes, faTrash } from "@fortawesome/free-solid-svg-icons";

const DetailRow = ({ label, value }) => (
  <div className="customer-detail-row">
    <dt>{label}</dt>
    <dd>{value || value === 0 ? value : "--"}</dd>
  </div>
);

export const CustomerDetailSidebar = ({
  customer, show, onClose, onEdit, onDelete, canEdit = true, canDelete = false,
  onPrevious, onNext, hasPrevious, hasNext,
}) => {
  const customerId = customer?.id;
  const details = customer;
  const representatives = Array.isArray(details?.representatives) ? details.representatives : [];

  return (
    <Modal show={show && customerId != null} onHide={onClose} dialogClassName="customer-detail-dialog" aria-labelledby="customer-detail-title">
      <Modal.Header className="customer-detail-header">
        <Modal.Title id="customer-detail-title" as="h5">Customer Details</Modal.Title>
        <div className="d-flex align-items-center">
          <Button variant="outline-secondary" size="sm" className="me-2" disabled={!hasPrevious} onClick={onPrevious} title="Previous customer">
            <FontAwesomeIcon icon={faChevronLeft} className="me-1" />Prev
          </Button>
          <Button variant="outline-secondary" size="sm" className="me-3" disabled={!hasNext} onClick={onNext} title="Next customer">
            Next<FontAwesomeIcon icon={faChevronRight} className="ms-1" />
          </Button>
          <Button variant="link" className="p-1 text-dark" onClick={onClose} aria-label="Close customer details">
            <FontAwesomeIcon icon={faTimes} />
          </Button>
        </div>
      </Modal.Header>
      <Modal.Body className="customer-detail-body">
        {details && <>
          <dl className="mb-4">
            <DetailRow label="Customer Name" value={details.name} />
            <DetailRow label="Mobile No." value={details.mobile} />
            <DetailRow label="Companies" value={(details.companies || []).map(company => company.name).filter(Boolean).join(", ")} />
            <DetailRow label="Industry Segment" value={details.industry_segment?.name} />
            <DetailRow label="Industry Sub Segment" value={details.industry_sub_segment?.name} />
            <DetailRow label="Address Line 1" value={details.address_line1} />
            <DetailRow label="Address Line 2" value={details.address_line2} />
            <DetailRow label="City" value={details.city} />
            <DetailRow label="State" value={details.state} />
            <DetailRow label="Country" value={details.country} />
            <DetailRow label="Pincode" value={details.pincode} />
            <DetailRow label="GST No." value={details.gst} />
            <DetailRow label="Status" value={details.status == null ? null : Number(details.status) === 1 ? "Active" : "Inactive"} />
          </dl>
          <h6>Customer Contacts</h6>
          {representatives.length === 0 ? <p className="text-muted mb-0">No customer contacts found.</p> : representatives.map((contact, index) => (
            <section className="customer-detail-contact" key={contact.id || index} aria-label={"Customer contact " + (index + 1)}>
              <dl className="mb-0">
                <DetailRow label="Name" value={contact.name} />
                <DetailRow label="Email" value={contact.email} />
                <DetailRow label="Phone" value={contact.phone} />
                <DetailRow label="Designation" value={contact.designation} />
                <DetailRow label="Department" value={contact.department_name} />
              </dl>
            </section>
          ))}
        </>}
      </Modal.Body>
      {details && (canEdit || canDelete) && <Modal.Footer>
        {canEdit && <Button variant="success" onClick={() => onEdit(customerId)}><FontAwesomeIcon icon={faEdit} className="me-2" />Edit</Button>}
        {canDelete && <Button variant="danger" onClick={() => onDelete(customerId)}><FontAwesomeIcon icon={faTrash} className="me-2" />Delete</Button>}
      </Modal.Footer>}
      <style>{`
        .modal .customer-detail-dialog { position: absolute; right: 0; top: 0; margin: 0; width: 600px; max-width: 100%; height: 100%; }
        .modal.fade .customer-detail-dialog { transform: translateX(100%); }
        .modal.show .customer-detail-dialog { transform: translateX(0); }
        .customer-detail-dialog .modal-content { height: 100%; max-height: 100%; border: 0; border-radius: 0; box-shadow: -4px 0 16px rgba(0, 0, 0, 0.15); }
        .customer-detail-header { flex-wrap: wrap; gap: .75rem; padding: 1rem 1.25rem; }
        .customer-detail-body { overflow-y: auto; padding: 1rem 1.25rem; }
        .customer-detail-row { display: flex; align-items: flex-start; justify-content: space-between; gap: 1rem; padding: .65rem 0; border-bottom: 1px solid #f1f1f1; }
        .customer-detail-row dt { flex: 0 0 40%; color: #526174; font-weight: 600; }
        .customer-detail-row dd { margin: 0; min-width: 0; text-align: right; overflow-wrap: anywhere; white-space: pre-wrap; }
        .customer-detail-contact { margin-top: .75rem; padding: .25rem 1rem; border: 1px solid #e5eaf0; border-radius: .5rem; }
        .customer-detail-contact .customer-detail-row:last-child { border-bottom: 0; }
        @media (max-width: 650px) { .modal .customer-detail-dialog { width: 100%; } }
        @media (prefers-reduced-motion: reduce) { .modal.fade .customer-detail-dialog { transition: none; } }
      `}</style>
    </Modal>
  );
};
